var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-button",
    {
      attrs: { type: "text", size: "small", disabled: _vm.disabled },
      on: { click: _vm.openDialog },
    },
    [_vm._v(" " + _vm._s(_vm.confirmOperate) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }